const MINUTE = 60 * 1000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;
const WEEK = 7 * DAY;
const MONTH = 30 * DAY;

const pluralize = (value: number, unit: string) =>
  `${value} ${unit}${value === 1 ? "" : "s"} Ago`;

export const formatRelativeTime = (isoDate: string): string => {
  const diffMs = Math.max(0, Date.now() - new Date(isoDate).getTime());

  if (diffMs < MINUTE) return "Just Now";
  if (diffMs < HOUR) return pluralize(Math.round(diffMs / MINUTE), "Minute");
  if (diffMs < DAY) return pluralize(Math.round(diffMs / HOUR), "Hour");
  if (diffMs < WEEK) return pluralize(Math.round(diffMs / DAY), "Day");
  if (diffMs < MONTH) return pluralize(Math.round(diffMs / WEEK), "Week");
  return pluralize(Math.round(diffMs / MONTH), "Month");
};

export default formatRelativeTime;
